import ShopLayout1 from "components/layouts/ShopLayout1";
import { NextPage } from "next";
import PCBuilderForm from "components/pcbuilder/PCBuilderForm";
import { useEffect, useState } from "react";
import { useAppDispatch } from "hooks/use-app-dispatch";
import modules from "modules";
import WorthBanner from "components/worth-it-builder/WorthBanner";
import { useLinkHandler } from "hooks";
import { colors, socialMediaLinks } from "common";
import { FlexBox } from "components/flex-box";
import { H2, H4, H5 } from "components/Typography";
import { useRouter } from "next/router";
import { useAppSelector } from "hooks/use-app-selector";
import { BuildProducts } from "modules/my-builds/types";
import { PartListItem, PartsCategory } from "modules/pcbuilder/types";
import { isComponentMultiple } from "modules/pcbuilder";

const { actions: pcBuilderActions } = modules.pcBuilder;
const { actions: myBuildsActions, selectors: myBuildsSelectors } =
  modules.myBuilds;

const PCBuilderPage: NextPage = () => {
  const dispatch = useAppDispatch();
  const { openFacebookPage } = useLinkHandler();
  const router = useRouter();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [buildProducts, setBuildProducts] = useState<
    (BuildProducts | PartListItem)[]
  >([]);

  const buildId = router?.query?.id as string;
  const buildDetails = useAppSelector(myBuildsSelectors.selectBuildDetails);
  const overwriteParts = useAppSelector(
    myBuildsSelectors.selectOverwriteBuildParts
  );

  const migrateOldPcBuilderData = () => {
    dispatch(pcBuilderActions.migrateOldBuildPart());
  };

  const getBuildDetails = async () => {
    const payload = { keyword: buildId };
    await dispatch(myBuildsActions.getBuildDetailsThunk(payload));
    setBuildProducts(buildDetails.build_products);
  };

  const handleSetProductsToBuilderForm = () => {
    setIsLoading(true);
    dispatch(pcBuilderActions.clearBuildParts());
    buildProducts.forEach((product) => {
      const category = product.category_name as PartsCategory;
      if (isComponentMultiple(category)) {
        dispatch(pcBuilderActions.addComponentOnMultipleItemType(product));
      } else {
        dispatch(pcBuilderActions.addComponent(product));
      }
    });
    dispatch(myBuildsActions.setOverwriteBuildParts(false));
    setIsLoading(false);
  };

  useEffect(() => {
    migrateOldPcBuilderData();

    // Reset configure build id if user navigated directly to diy builder
    if (!buildId) {
      dispatch(myBuildsActions.clearConfigureBuildId());
    } else {
      getBuildDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // Overwrite parts ONLY if user performed "edit components" from /my-builds page
    if (overwriteParts && buildProducts?.length > 0) {
      handleSetProductsToBuilderForm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buildProducts]);

  return (
    <ShopLayout1 title="DO IT YOURSELF BUILDER" hasSearch={false}>
      <WorthBanner
        title={"DO IT YOURSELF BUILDER"}
        cover={"/assets/images/banners/diyBG.png"}
        subtitle="This feature is for knowledgeable and experienced pc enthusiast"
      />
      <PCBuilderForm
        configureBuild={buildId ? true : false}
        buildDetails={buildId ? { ...buildDetails, build_id: buildId } : null}
      />
      <FlexBox flexDirection="column" paddingX={2}>
        <H2>{"Notes"}</H2>
        <FlexBox mt={1} py={1} borderTop="1px solid #7D879C">
          <H4 color="grey.900" fontSize={16}>
            Please send us a message on our
            <H5
              display="inline"
              mx={0.5}
              onClick={openFacebookPage}
              sx={{ color: colors.link, cursor: "pointer" }}
            >
              {`facebook page (${socialMediaLinks?.facebookFullUrl})`}
            </H5>
            if you have any questions about compatibility
          </H4>
        </FlexBox>
      </FlexBox>
    </ShopLayout1>
  );
};

export default PCBuilderPage;
